// Import Services
import Services from '../core/services'

export default {

  processEnrollments( formData ) {

    return new Promise((resolve) => {
      return Services
        .post(`api/lotteryenrollment/processenrollments`, formData )
        .then( ({data}) => {
          if (data && data.success) {
            return resolve({
              success: true
            });  
          }

          return resolve({
            success: false,
            error: data.error,
          });
        })
        .catch(() => {
          return resolve({
            success: false
          });
        });
    });
  }

}